export default "__VITE_ASSET__b50a07b7__"